<div
  class="tag"
  [ngClass]="{
    'green': !date,
    'blue': date,
  }"
>
  <span>{{ date | officerStatus }}</span>
</div>
